import {
  VTextField,
  VTextarea,
  VSelect,
  VAutocomplete,
} from 'vuetify/components';

import GroupedFieldsExpansionPanel from '@/components/form/GroupedFieldsExpansionPanel.vue'
  
import type { FormField } from '@/types/form';

export const CREATE_FORM: FormField[] = [  
  { value: 'user', 
    permission_state:'hidden',
    permission:'leads.assign',
    label: 'Vendedor', 
    component: VAutocomplete, 
    searchValue: 'name', 
    required: false, 
    col: 6, 
    fetchOptions: 'searchUsers', 
    itemText: (item: any) => [item?.name, item?.last_name].filter(Boolean).join(' ') || '', 
    itemValue: (item: any) => item,
    transform: (value: any) => ({
      user_id: value?.id,
    }),
    fetchParams: () => ({
      'filter[is_active]': 1
    }),
  },
  { value: 'client_type', 
    label: 'Tipo de Cliente', 
    component: VAutocomplete, 
    searchValue: 'name', 
    required: true, 
    col: 6, 
    mdcol:12, 
    fetchOptions: 'getClientTypes', 
    itemText: 'name', 
    itemValue: (item: any) => item,
    transform: (value: any) => ({
      client_type_id: value?.id,
    }) 
  },
  { value: 'name', label: 'Nombre', component: VTextField, required: false, col: 6, mdcol:12 },
  { value: 'last', label: 'Apellido', component: VTextField, required: false, col: 6, mdcol:12 },
  { value: 'email', label: 'Email', component: VTextField, required: false, col: 6, mdcol:12 },
  { value: 'phone', label: 'Teléfono', component: VTextField, required: false, col: 6, mdcol:12 },
  { value: 'origin', 
    label: 'Origen', 
    component: VSelect, 
    searchValue: 'name', 
    required: false, 
    col: 6, 
    fetchOptions: 'originsFromStore', 
    itemText: 'name', 
    itemValue: 'name'
  },
  {
    value: 'note',
    label: 'Nota',
    component: VTextarea,
  },
];

const idFieldMappings: Record<string, string> = {
  client_type_id:'client_type',
  user_id: 'user',
};

export const EDIT_FORM: FormField[] = [...CREATE_FORM.map(field => {
  const relatedKey = idFieldMappings[field.value];
  if (relatedKey) {
    return {
      ...field,
      parse: (_: any, item: any) => item[relatedKey] || null,
      transform: (val: any) => ({
        [field.value]: field.multiple
          ? (Array.isArray(val)
              ? val.map(v => v?.[field.itemValue || 'id'] ?? v)
              : [])
          : val?.id ?? val
      })
    };
  }
  return field;
})]

export const HEADERS = [
  { title: 'ID', value: 'id', format: 'text', sortable: true },
  { title: 'Nombre', value: 'attributes.name', format: 'text', sortable: true },
  { title: 'Teléfono', value: 'attributes.phone', format: 'text', sortable: true },
  { title: 'Correo', value: 'attributes.email', format: 'text', sortable: true },
  { title: 'Interes', value: 'attributes.interest', format: 'text', sortable: true },
  { title: 'Canal', value: 'attributes.channel', format: 'text', sortable: true },
  { title: 'Origen', value: 'attributes.origin', format: 'text', sortable: true },
  { title: 'Vendedor', value: 'user', format: 'text', sortable: true },
  { title: 'Tipo', value: 'attributes.client_type.name', format: 'text', sortable: false },
  { title: 'Nota', value: 'attributes.note', format: 'text', sortable: false },
];

export const DEFAULT_HEADER_ORDER = [
  'id',
  'attributes.name',
  'attributes.phone',
  'attributes.email',
  'attributes.origin',
  'attributes.user',
  'attributes.client_type.name'
];

export const DETAIL = {
  expand_table: false,
  eye_detail: false,
  key: 'all',
};

export const ROW_ACTIONS = [
  { label: 'Editar', onClick: '__edit', permission:'leads.update' },
  { label: 'Eliminar', onClick: '__delete', permission:'leads.delete' },
  { label: 'Convertir', onClick: 'convertLeadToClient', permission:'leads.convert' },
];

export const FILTERS = [
  { value: 'id', label: 'ID', component: VTextField },
  { value: 'name', label: 'Nombre', component: VTextField },
  { value: 'email', label: 'Correo Electrónico', component: VTextField },
  { value: 'phone', label: 'Teléfono', component: VTextField },
  { value: 'origin', label: 'Origen', component: VTextField },
  { value: 'user_id', label: 'Vendedor', component: VAutocomplete, fetchOptions: 'searchUsers', 
    searchValue: 'name',
    itemText: (item: any) => [item?.name, item?.last_name].filter(Boolean).join(' ') || '',
    itemValue: (item: any) => item,
    transform: (values: any) => ({
      user_id: Array.isArray(values)
      ?values.map(v=>v.id??v).join(',')
      :values?.id ?? values
    }),
    multiple:true
  },
];
